import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'

const GrantLoading = () => {

	const App = useApp()
	
	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})
		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_other_search" />
				<h3 className="intro-tit mt_30">잠시만 기다려주세요!</h3>
				<span className="intro-sub-tit mt_10">
					김모니님에게 꼭 맞는<br />
					정부지원금 혜택을 찾고 있어요!
				</span>
				<div className="mt_30">
					<div className="load-progress">
						<span style={{ width: "50%" }} />
					</div>
					<span className="mt_10">최대 2분</span>
				</div>
			</div>
		</div>
	)
}

export default GrantLoading